import { InputHTMLAttributes } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | null;
  formik: any;
  fieldName: string;
  required?: boolean;
}

const CustomPhoneInput = ({
  label,
  formik,
  fieldName,
  required = false,
  ...rest
}: Props) => {
  const handleChange = (value: string) => {
    formik.setFieldValue(fieldName, value);
  };

  return (
    <>
      {label && (
        <label
          htmlFor={fieldName}
          className={`add-staff-label font-16 fw-bold mb-2 ${
            required ? "required" : ""
          }`}
        >
          {label}
        </label>
      )}
      <PhoneInput
        className={`form-control ${
          formik.errors[fieldName] && formik.touched[fieldName]
            ? "is-invalid"
            : ""
        }`}
        id={fieldName}
        {...formik.getFieldProps(fieldName)}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        defaultCountry="US" // Set your default country here
        {...rest}
      />
      {formik.touched[fieldName] && formik.errors[fieldName] && (
        <div className="invalid-feedback">{formik.errors[fieldName]}</div>
      )}
    </>
  );
};

export default CustomPhoneInput;
